// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GPae2","label":"styles_label__dBi_z"};